import { render, staticRenderFns } from "./OwnCameraReproduction.vue?vue&type=template&id=156b225b&"
import script from "./OwnCameraReproduction.vue?vue&type=script&lang=js&"
export * from "./OwnCameraReproduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports